module.exports = "pegasus/assets/themelp1/coming_soon/101.png";